// Packing room (ห้องแพ็ค): which product cards are scanned, and whether the
// whole order is. Pure and vue-free so jest can test it — the shipping forms
// themselves cannot be mounted (see tests/unit/packingScanSource.spec.js).
//
// docs/specs/2026-10-06-packing-scanned-highlight-design.md §3 P4.
//
// A piece is scanned when its `pickup_need` has been cleared: null, or absent
// (undefined). 0 is still a number the forms compare against, so it is NOT
// scanned. An empty or missing list is never "all scanned" — a fresh or just
// closed order must not show the green line.

export function isScanned(item) {
  return !!item && item.pickup_need == null;
}

export function allScanned(items) {
  return Array.isArray(items) && items.length > 0 && items.every(isScanned);
}

export function scannedCardClass(item) {
  return { "packing-item--scanned": isScanned(item) };
}
